import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';
var Status;

(function (Status) {
  Status[Status["AVAILABLE"] = 0] = "AVAILABLE";
  Status[Status["UNAVAILABLE"] = 1] = "UNAVAILABLE";
  Status[Status["PENDING"] = 2] = "PENDING";
})(Status || (Status = {}));

var shareBases = {
  facebook: 'https://www.facebook.com/sharer/sharer.php?u=',
  pinterest: 'https://pinterest.com/pin/create/button/?url=',
  twitter: 'https://twitter.com/share?url=',
  linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url='
};
export function useSocialShare() {
  var _React$useState = React.useState(Status.PENDING),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      shareStatus = _React$useState2[0],
      setShareStatus = _React$useState2[1];

  React.useEffect(function () {
    var navigatorShare = window.navigator.share;
    setShareStatus(navigatorShare ? Status.AVAILABLE : Status.UNAVAILABLE);
  }, []);
  return {
    canNativelyShare: shareStatus === Status.AVAILABLE,
    isLoading: shareStatus === Status.PENDING,
    share: share
  };
}

function share(_ref) {
  var title = _ref.title,
      text = _ref.text,
      url = _ref.url,
      socialMedia = _ref.socialMedia,
      classic = _ref.classic;

  if (classic) {
    socialMedia && openSharePopup(socialMedia, url);
  } else {
    navigator.share({
      title: title,
      text: text,
      url: url
    });
  }
}

function openSharePopup(socialMedia, url) {
  window.open(shareBases[socialMedia] + url, 'popup', 'height=650,width=650');
}